import { render, staticRenderFns } from "./sync-save.vue?vue&type=template&id=41bab96c&scoped=true&"
import script from "./sync-save.vue?vue&type=script&lang=js&"
export * from "./sync-save.vue?vue&type=script&lang=js&"
import style0 from "./sync-save.vue?vue&type=style&index=0&id=41bab96c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bab96c",
  null
  
)

export default component.exports